import type { Account } from "Utils/types";

export const RECEIVE_ACCOUNT_DATA = "SwitchFlow/RECEIVE_ACCOUNT_DATA";

export const receiveAccountData = (response: Account) => ({
  type: RECEIVE_ACCOUNT_DATA,
  payload: response,
});
